import { Box, Text, Flex } from '@chakra-ui/layout'
import { AutoComplete } from './AutoComplete'
import { FilterSection } from './FilterSection'

export function SidebarHeader() {
  return (
    <Box
      paddingTop={{ base: '20px', notebook: '32px' }}
      paddingLeft={{ base: '20px', notebook: '24px' }}
      paddingRight={{ base: '20px', notebook: '24px' }}
    >
      <Text
        marginBottom="16px"
        fontSize={{ base: '16px', notebook: '24px' }}
        fontWeight="700"
      >
        Parceiros da ParkOff perto de você
      </Text>
      <AutoComplete />
      <FilterSection />
    </Box>
  )
}
